/**
 * @typedef {Object} View
 * @property {Array<string|number>} cams Cameras ids: [cam1id,cam2id,cam3id,...]
 * @property {number} grid View grid: 4
 * @property {number} id View id: 1
 * @property {string} name View name: View 1
 */

/**
 * @class LocalView
 * @property {Array<string|number>} cams Cameras ids: [cam1id,cam2id,cam3id,...]
 * @property {number} grid View grid: 4
 * @property {string} id View id: localView1
 * @property {string} name View name: View 1
 * @property {boolean} changed don't know
 * @property {boolean} temp don't know
 * @property {boolean} selected don't know
 * @property {boolean} isGlobalView is global view flag
 */

export class LocalView {
  /**
   * @param {View} view
   */
  constructor(view) {
    this.cams = view.cams;
    this.grid = view.grid;
    this.id = view.id;
    this.name = view.name;

    this.changed = false;
    this.temp = false;
    this.selected = false;

    this.isGlobalView = false;
  }
}



// WEBPACK FOOTER //
// ./src/classes/views/localView.js